export default __webpack_public_path__ + "static/media/thumbnail.3a08a448.png";